---
fr:
  work_items:
    add_attachment: Ajouter une pièce jointe
    attachments: Pièces jointes
    average_cost_per_closed_work_item: Coût moyen par tâche terminée
    average_days_to_close_work_item: Nombre moyen de jours pour terminer une tâche
    budget_cost: Coût budgétaire
    closed_tasks: Tâches terminées
    closed_work_items: Tâches terminées
    due_date: Date d'échéance
    error_deleting: Une erreur est survenue durant la suppression de la tâche
    filter_responsibles: Filtre responsables
    forecast_cost: Coût prévisionnel
    history: Historique
    label_in_use: Utilisée par {count} tâche. Contactez le support pour la modifier. | Utilisée par {count} tâches. Contactez le support pour la modifier.
    label_in_use_error:
      one: Cette étiquette est utilisée par une tâche, seul le support peut la modifier.
      other: Cette étiquette est utilisée par %{count} tâches, seul le support peut la modifier.
    model_name: Tâche
    move: Déplacer
    moved_work_item_from: a déplacé la tâche de
    new_label: Nouvelle étiquette
    no_attachments: Aucune pièce jointe
    not_allowed_to_delete: Vous ne pouvez supprimer que vos propres tâches
    number_of_projects: Nombre de projets
    number_of_work_items: Nombre de tâches
    open_work_items: Tâches ouvertes
    opened_work_item: a ouvert la tâche
    project_status: État du projet
    reassigned_work_item_from: a réassigné la tâche de
    show_closed_tasks: Voir les tâches terminées
    show_on_hold_tasks: Afficher les tâches en attente
    show_only_closed_tasks: Voir uniquement les tâches terminées
    show_only_on_hold_tasks: Afficher uniquement les tâches en attente
    started_on: Commencé le
    status:
      closed: Terminé
      in_progress: En cours
      on_hold: En attente
      open: Ouvert
    sum_total_cost: Coût total cumulé
    today: Aujourd'hui
    total_budget_cost: Coût budgétaire total
    total_closed_cost: Coût total des tâches terminées
    total_closed_cost_by_month: Coût total des tâches terminées par mois
    total_cost_by_month: Coût total des tâches
    total_in_progress_cost: Coût total des tâches en cours
    total_open_cost: Coût total des tâches ouvertes
    total_open_cost_by_month: Coût total des tâches ouvertes par mois
    validations:
      select_power_plant_first: Veuillez d'abord sélectionner la centrale électrique
    work_item_labels: Étiquettes de tâche
    work_item_total_cost_by_month: Coût total des tâches par mois
    work_items_by_component: Pourcentage des tâches par composant
    work_items_by_status_by_month: Tâches ouvertes et terminées par mois
